import { flattenEdges } from "@pathwright/web/src/modules/utils/apollo"

export const createPathFromItems = (items) =>
  items
    // filtering by !item.parent_id breaks for legacy paths
    .filter(
      (item) =>
        item.type === "lesson" ||
        item.type === "divider" ||
        item.type === "resource"
    )
    .sort((itemA, itemB) => itemA.order - itemB.order)
    .map((lesson) => ({
      ...lesson,
      items: items
        .filter((item) => item.parent_id === lesson.id)
        .sort((itemA, itemB) => itemA.order - itemB.order)
    }))

export const serializeItemForState = ({ item, offering, resource }) => {
  return {
    ...item,
    item_type: {
      lesson: "G",
      step: "A",
      divider: "T",
      resource: "R"
    }[item.type],
    sync_source_id: item.source_id,
    parent: item.parent_id,
    content: item.content_id
      ? {
          id: item.content_id,
          type: item.content_type
          // method: null - requires more SQL overhead but isn't necessary as the step component loads content fine without it
        }
      : null,
    ...(item.type === "step"
      ? {
          step_verb: item.verb,
          is_skipped: item.completion.is_skipped,
          userpoints_value: item.completion.userpoints_value,
          has_started: item.has_started,
          is_locked: item.is_locked
        }
      : {}),
    completion: serializeCompletionForState(item),
    url: `/library/${resource.slug}/${offering.id}/path/${item.type}/${item.source_id}/`
  }
}

export const serializeCompletionForState = (item) => {
  return item.type === "step" || item.type === "lesson"
    ? {
        ...item.completion,
        allow_resets: item.allow_resets,
        is_required: item.is_required,
        item_needs_grading: item.item_needs_grading,
        minimum_passing_score: item.minimum_passing_score,
        progress: item.progress,
        show_grading_feedback: item.show_grading_feedback,
        step: item.id,
        step_source_id: item.source_id,

        ...(item.completion.submission
          ? {
              submission_file_image: item.completion.submission.file_image,
              submission_file_name: item.completion.submission.file_name,
              submission_file_url: item.completion.submission.file_url,
              submission_text: item.completion.submission.text
            }
          : {}),

        userpoints_earned: item.completion.userpoints_earned,
        userpoints_explanation: item.completion.userpoints_explanation,
        userpoints_percentage:
          item.completion.userpoints_earned %
            item.completion.userpoints_value || 0,
        userpoints_value: item.completion.userpoints_value,

        user:
          item.completion.user && user && item.completion.user.id === user.id
            ? user
            : item.completion.user,
        checked_by: {
          ...item.completion.checked_by
        }
      }
    : null
}

// massage the path data into the expected shape for the path store
export const serializePathForStore = ({ path, resource, offering, user }) => {
  path = flattenEdges(path)
  let nextStep = path.items.find(
    (item) =>
      (item.id === path.next_step_id || item.source_id === path.next_step_id) &&
      item.type === "step"
  )

  // Likely no next step set on the path, so choose the first incomplete, completetable path item
  if (!nextStep) {
    nextStep = path.items
      .filter((item) => item.type === "step")
      .find((item) => item.progress < 1)
  }

  path = {
    completion: {
      completion_date: path.completion_date,
      ...(nextStep
        ? {
            next_step: nextStep.id,
            next_step_source_id: nextStep.source_id,
            next_step_url: `/library/${resource.slug}/${offering.id}/path/${nextStep.type}/${nextStep.source_id}/`
          }
        : {}),
      progress: path.progress,
      userpoints_available: path.points.total,
      userpoints_earned: path.points.earned
    },
    points: path.points,
    schedule: path.schedule,
    id: path.id,
    synced: path.sync.synced,
    last_synced_dtime: path.sync.last_synced_date,
    offering_id: offering.id,
    resource_id: resource.id,
    url: `/library/${resource.slug}/${offering.id}/path/`,
    user: path.user ? path.user.id : null,
    items: createPathFromItems(
      path.items.map((item) =>
        serializeItemForState({ item, offering, resource })
      )
    )
  }

  return path
}

export const usePathParamIds = (props) => {
  const { cohortId } = props.params
  const { path_id } = props.location.query

  return {
    cohortId: parseInt(cohortId),
    pathId: parseInt(path_id)
  }
}
